export default __webpack_public_path__ + "static/media/style0.dd446a68.svg";